/**
 * The country's campaign groups, from the SMSWiser catalog the page already
 * loads (useCountry) — memoised, so every reader shares one index.
 * For Media Devoted | Created By Ciro Autiero
 */
import { useMemo } from 'react';

import { useCountry } from '@/hooks/smswiser/core/useSMSWiser';

import { type GroupIndex, indexGroups } from './group-index';

export function useCampaignGroups(countryKey: string): GroupIndex & { loaded: boolean } {
  const country = useCountry(countryKey);
  const campaigns = country.data?.campaigns;
  return useMemo(() => ({ ...indexGroups(campaigns ?? []), loaded: Boolean(campaigns) }), [campaigns]);
}
